import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "attribute-tags" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.attributes, (tag) => {
      return (_openBlock(), _createElementBlock("span", {
        key: tag.id,
        class: "badge badge-primary me-1"
      }, _toDisplayString($setup.getAttributeValueById($props.question, tag.id)), 1))
    }), 128))
  ]))
}